export default class Navigation {
  constructor(private container: HTMLElement) {
    this.bindNavHover();
  }

  static initAll(): void {
    Array
      .from(document.querySelectorAll<HTMLElement>('.js-navigation'))
      .map((el) => new Navigation(el));
  }

  private bindNavHover(): void {
    $(this.container).find('.js-navigationWithSubmenu').hoverIntent({
      over() {
        const element = $(this);
        const subNav = element.find('.js-subNavigation');
        const mainNav = $('.js-navigation');

        const subNavWidth = subNav.outerWidth() as number;
        const mainNavWidth = mainNav.width() as number;

        // get the left position for sub-navigation to be centered under each <li>
        const leftPos = element.position().left;
        // get the top position for sub-navigation. this is usually the height of the <li> unless there is more than one row of <li>
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        const topPos = element.position().top + (element.height() ?? 0);
        if (leftPos + subNavWidth > mainNavWidth) {
          // .suv-navigation can't be centered under the <li> because it would exceed the .main-navigation on the right side
          subNav.css({
            right: 0,
            top: topPos,
            left: 'auto',
          });
        } else {
          subNav.css({
            // left: leftPos,
            left: 0,
            top: topPos,
            right: 'auto',
          });
        }
        element.addClass('-show-sub');
        subNav.slideDown(200);
      },
      out() {
        const $this = $(this);
        const $subNav = $this.find('.js-subNavigation');
        $subNav.slideUp(200, () => {
          $this.removeClass('-show-sub');
        });
      },
    });
  }
}
